
import Split from '../layouts/Split'

import RealExperiencesImage from '../../assets/images/home-page/Real-Experiences.png'
  
  export default function ExperiencesSection() {
    return (
      <div className="real-experiences-section">
        <Split
            leftImage
            img={RealExperiencesImage}
            imgAlt=''
            title1='Real Experiences'
            title2='of women in Tech'
            description='by sharing experiences of women in tech and educating allies through our modules. We empower people to make a difference.'
            buttonText='Experiences'
            buttonUrl='/experiences'
        />
      </div>
    );
  }